import { c as _c } from "react/compiler-runtime";
import { useClerkSignUp } from '@lib/clerk/hooks/use-clerk-signup';
import { APP_ROUTES } from '@lib/constants/apis';
import { useMutation } from '@lib/query/client';
export interface SignUpCredentials {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
}
type SignUpOutcome = {
  status: 'complete';
} | {
  status: 'shell_claim_code_sent';
  email: string;
  fullName: string;
} | {
  status: 'failed';
};
export interface UseSignUpResult {
  signUp: (credentials: SignUpCredentials, redirectTo?: string) => Promise<SignUpOutcome>;
  isLoading: boolean;
  error: string | null;
}
export function useSignUp() {
  const $ = _c(8);
  const {
    signUpWithCredentials,
    isLoading,
    error
  } = useClerkSignUp();
  let t0;
  if ($[0] !== signUpWithCredentials) {
    t0 = {
      mutationFn: async t1 => {
        const {
          credentials,
          redirectTo
        } = t1;
        const outcome = await signUpWithCredentials(credentials, redirectTo ?? APP_ROUTES.ONBOARDING);
        if (outcome === "complete") {
          return {
            status: "complete"
          };
        }
        if (outcome === "identifier_exists") {
          return {
            status: "shell_claim_code_sent",
            email: credentials.email,
            fullName: `${credentials.firstName} ${credentials.lastName}`.trim()
          };
        }
        return {
          status: "failed"
        };
      }
    };
    $[0] = signUpWithCredentials;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const mutation = useMutation(t0);
  let t1;
  if ($[2] !== mutation) {
    t1 = (credentials_0, redirectTo_0) => mutation.mutateAsync({
      credentials: credentials_0,
      redirectTo: redirectTo_0
    });
    $[2] = mutation;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = isLoading || mutation.isPending;
  const t3 = error || (mutation.error instanceof Error ? mutation.error.message : null);
  let t4;
  if ($[4] !== t1 || $[5] !== t2 || $[6] !== t3) {
    t4 = {
      signUp: t1,
      isLoading: t2,
      error: t3
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}